import React, { useEffect, useState, useContext, useMemo } from 'react';
import { Checkbox, Form, Select, Input } from 'antd';
import classnames from 'classnames';
import { apiHolder as api, apis } from 'api';
import { MailActions, useActions, useAppSelector, TempContactActions, ContactActions } from '@web-common/state/createStore';
import { MemberChooserModal } from '@web-im/components/MemberChooser/memberChooser';
import { WriteContext } from '@web-setting/Mail/components/CustomTemplate/template_add_modal';
import IconCard from '@web-common/components/UI/IconCard';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import MedalChooser from './MedalChooser';
import ContactChip from './ContactChip';
import { SelectorProvider } from '@web-mail-write/components/Selector/SelectorContext';
import { transContactModel2MailContactModel } from '@web-common/utils/contact_util';
import styles from '../mailInfo.module.scss';
import { getIn18Text } from 'api';
const { TextArea } = Input;
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const PraiseMailSetting = ({ deletePraiseMail }) => {
    const mailActions = useActions(MailActions);
    const praiseMail = useAppSelector(state => state.mailReducer.currentMail.praiseMail);
    const curAccount = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSender; });
    const [addToReceiver, setAddToReceiver] = useState(true);
    const [addMemberVisible, setAddMemberVisible] = useState(false);
    const [medalChooserVisible, setMedalChooserVisible] = useState(false);
    const [chosenMedal, setChosenMedal] = useState();
    const [selectedItems, setSelectedItems] = useState([]);
    const [form] = Form.useForm();
    const { isMailTemplate } = useContext(WriteContext);
    const onContactActions = isMailTemplate ? TempContactActions : ContactActions;
    const { doAddItemToSelector, doFocusSelector } = useActions(onContactActions);
    const asyncRecordPraiseMailData = () => {
        setTimeout(() => {
            console.log('form.getFieldsValue(true)', form.getFieldsValue(true));
            mailActions.doPraiseMailChange(form.getFieldsValue(true));
        }, 0);
    };
    const formChange = () => {
        asyncRecordPraiseMailData();
    };
    const onCheckChange = e => {
        const checked = e.target.checked;
        setAddToReceiver(checked);
        trackApi.track(`pcMail_click_writeMail_addPraiseLetterPage_${checked ? 'select' : 'cancel'}AutoAdd`);
        if (checked) {
            doFocusSelector('to');
            doAddItemToSelector({
                add: true,
                pendingItem: selectedItems,
            });
        }
    };
    const addMedal = () => {
        trackApi.track('pcMail_click_writeMail_addPraiseLetterPage_selectMedal');
        setMedalChooserVisible(true);
    };
    const closeMedalChooser = () => {
        setMedalChooserVisible(false);
    };
    const chooseMedal = (medalId) => {
        setChosenMedal(medalId);
        closeMedalChooser();
    };
    const closeMemberChooser = () => {
        setAddMemberVisible(false);
    };
    const openMemberChooser = async () => {
        trackApi.track('pcMail_click_writeMail_addPraiseLetter_addMember');
        setAddMemberVisible(true);
    };
    const changeWinners = (winners) => {
        setSelectedItems(winners);
        form.setFieldsValue({
            winners,
        });
        asyncRecordPraiseMailData();
    };
    const addMembers = (newMembers) => {
        let formatWinners = (items) => {
            let map = new Map();
            for (let item of items) {
                if (!map.has(item.contact.id)) {
                    map.set(item.contact.id, item);
                }
            }
            return [...map.values()];
        };
        const winners = formatWinners(selectedItems.concat(newMembers));
        if (winners.length <= 500) {
            if (addToReceiver) {
                doFocusSelector('to');
                doAddItemToSelector({
                    add: true,
                    pendingItem: newMembers,
                });
            }
            changeWinners(winners);
            closeMemberChooser();
        }
        else {
            Message.warn({
                content: getIn18Text('BIAOYANGDUIXIANGZUI'),
            });
        }
    };
    const tagRender = (tagProps) => {
        const { value, onClose } = tagProps;
        const item = selectedItems.find(cur => contactApi.findContactInfoVal(cur.contactInfo) === value);
        if (!item) {
            return React.createElement("div", null);
        }
        const onTagClose = () => {
            onClose();
            changeWinners(selectedItems.filter(cur => contactApi.findContactInfoVal(cur.contactInfo) !== value));
        };
        return React.createElement(ContactChip, { value: item.contact.accountName, onClose: onTagClose, item: item });
    };
    useEffect(() => {
        form.setFieldsValue({
            medalId: chosenMedal,
        });
        asyncRecordPraiseMailData();
    }, [chosenMedal]);
    useEffect(() => {
        if (praiseMail) {
            setChosenMedal(praiseMail.medalId);
            setSelectedItems(praiseMail.winners || []);
            form.setFieldsValue(praiseMail);
        }
    }, [praiseMail]);
    const [allMedals, setMedals] = useState([]);
    useEffect(() => {
        mailApi.doGetPraiseMedals().then(setMedals);
    }, []);
    const curMedal = allMedals.find(item => item.id === chosenMedal);
    const selectorItems = useMemo(() => selectedItems.map(item => transContactModel2MailContactModel(item, 'to')), [selectedItems]);
    return (React.createElement("div", { className: styles.praiseMailForm },
        React.createElement(Form, { form: form, onValuesChange: formChange },
            React.createElement("div", { className: classnames([styles.infoItem]) },
                React.createElement("span", { className: styles.infoLabel }, getIn18Text('BIAOYANGDUIXIANG')),
                React.createElement("span", { className: styles.colonLabel }, ":"),
                React.createElement("div", { className: classnames([styles.btnBox, styles.closeBtn]) },
                    React.createElement("span", { className: classnames([styles.labelBtn, styles.labelCloseBtn]), onClick: deletePraiseMail },
                        React.createElement(IconCard, { className: "dark-invert", type: "close" }))),
                React.createElement("div", { className: classnames(styles.memberBox) },
                    React.createElement("div", { className: classnames('ant-allow-dark', styles.memberList) },
                        React.createElement(SelectorProvider, { items: selectorItems, type: "to", selectedEmails: [] },
                            React.createElement(Select, { mode: "tags", open: false, bordered: false, value: (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map(item => contactApi.findContactInfoVal(item.contactInfo, 'EMAIL'))) || [], tagRender: tagRender })),
                        React.createElement("div", { className: classnames(styles.addMemberBtn), onClick: openMemberChooser }, getIn18Text('QIYECHENGYUAN'))),
                    React.createElement("div", { className: classnames('ant-allow-dark', styles.checkBox) },
                        React.createElement(Checkbox, { onChange: onCheckChange, checked: addToReceiver }, getIn18Text('JIANGBIAOYANGDUIXIANG'))))),
            React.createElement("div", { className: classnames([styles.infoItem]) },
                React.createElement("span", { className: styles.infoLabel }, getIn18Text('BANFAXUNZHANG')),
                React.createElement("span", { className: styles.colonLabel }, ":"),
                React.createElement("div", { className: classnames(styles.conferenceTime) }, curMedal ? (React.createElement("div", { className: classnames(styles.medalWrapper), onClick: addMedal },
                    React.createElement("div", { className: classnames(styles.medalMask) },
                        React.createElement("div", { className: classnames(styles.changeIcon) })),
                    React.createElement("img", { className: classnames(styles.medalImg), alt: curMedal.name, src: curMedal.imageUrl }))) : (React.createElement("div", { className: classnames(styles.addMedalBtn), onClick: addMedal })))),
            React.createElement("div", { className: classnames([styles.infoItem, styles.infoItemWithoutLine]) },
                React.createElement("span", { className: styles.infoLabel }, getIn18Text('BANJIANGCI')),
                React.createElement("span", { className: styles.colonLabel }, ":"),
                React.createElement("div", { className: classnames('ant-allow-dark', styles.conferenceTime) },
                    React.createElement("div", { className: styles.inputWrapper },
                        React.createElement(Form.Item, { label: "", shouldUpdate: true }, ({ getFieldValue }) => {
                            const presentationWords = getFieldValue('presentationWords');
                            return (React.createElement(Form.Item, { noStyle: true, name: "presentationWords" },
                                React.createElement(TextArea, { placeholder: getIn18Text('SHURU300'), value: presentationWords, showCount: true, maxLength: 300, autoSize: { minRows: 1, maxRows: 3 } })));
                        })))),
            React.createElement("div", { className: classnames([styles.infoItem, styles.infoItemWithoutLine]) },
                React.createElement("span", { className: styles.infoLabel }, getIn18Text('BANJIANGREN')),
                React.createElement("span", { className: styles.colonLabel }, ":"),
                React.createElement("div", { className: classnames('ant-allow-dark', styles.conferenceTime) },
                    React.createElement("div", { className: styles.inputWrapper },
                        React.createElement(Form.Item, { label: "", shouldUpdate: true }, ({ getFieldValue }) => {
                            const presenter = getFieldValue('presenter');
                            return (React.createElement(Form.Item, { noStyle: true, name: "presenter" },
                                React.createElement(Input, { placeholder: getIn18Text('SHURUBANJIANGREN'), maxLength: 20, style: { width: '100%' }, value: presenter })));
                        }))))),
        React.createElement(MemberChooserModal, { visible: addMemberVisible, type: "EMAIL", title: getIn18Text('TIANJIABIAOYANGDUI'), chosenMembers: selectedItems, account: curAccount === null || curAccount === void 0 ? void 0 : curAccount.mailEmail, onOk: addMembers, onCancel: closeMemberChooser }),
        React.createElement(MedalChooser, { visible: medalChooserVisible, chosenMedal: curMedal, chooseMedal: chooseMedal, onCancel: closeMedalChooser })));
};
export default PraiseMailSetting;
